import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const HighBloodSugarIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M4.99973 1C4.99973 1.56 5.44973 2 5.99973 2H11.5897L0.699727 12.89C0.309727 13.28 0.309727 13.91 0.699727 14.3C1.08973 14.69 1.71973 14.69 2.10973 14.3L12.9997 3.41V9C12.9997 9.55 13.4497 10 13.9997 10C14.5497 10 14.9997 9.55 14.9997 9V1C14.9997 0.45 14.5497 0 13.9997 0H5.99973C5.44973 0 4.99973 0.45 4.99973 1Z"
        fill={color}
      />
    </IconBase>
  );
};

export default HighBloodSugarIcon;
